import './style.less';
import * as React from 'react';
import { Card } from 'telstra-ui/components/card/Card';

interface ICardLoadingIndicatorProps {
    error?: boolean;
    cardTitle: string;
};

export class CardLoadingIndicator extends React.Component<ICardLoadingIndicatorProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { error } = this.props;
        const isError = !!error;
        const isLoading: boolean = !error;
        return (
            <div className={`tc-dashboard-cards-container.container panel panel-default`}>
                <Card
                    duration={60000}
                    error={isError}
                    errorTitle={this.props.cardTitle}
                    errorBody={this.renderErrorBody()}
                    errorCallback={this.handleErrorCallback()}
                    loading={isLoading}
                />
            </div>
        );
    }

    private renderErrorBody() {
        return (
            <div className="tc-srm-card-error">
                <div className="tc-srm-card-error__body">
                    <i className="tc-telstra-icon alert-round tc-icon-md-50 tc-srm-card-error__body__icon" />
                    <div>
                        There was an error loading<br />
                        this app
                    </div>
                </div>
            </div>
        );
    }

    private handleErrorCallback() {
        return () => window.location.reload();
    }
}
